import React from 'react'
import { typeCisUserList, typeContractList } from '../../../api/helpline/keiyaku'
import {
  Grid, Button, InputLabel, MenuItem, FormControl,
  Select, makeStyles, Theme, createStyles, Paper, CircularProgress,
  Chip, Checkbox, ListItemText, Accordion, Typography,
  AccordionDetails, AccordionSummary, TextField, FormControlLabel
} from '@material-ui/core';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { green } from '@material-ui/core/colors';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { typeCustomerList } from '../../../api/helpline/qa';
import { Autocomplete } from '@material-ui/lab';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '80%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0,
    },
    mWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "80%",
      minWidth: "40%"
    },
    lWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "100%",
      minWidth: "30%"
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    chip: {
      margin: "2px 2px 2px"
    },
    button: {
      margin: theme.spacing(1),
    },
    departmentWidth: {
      marginTop: theme.spacing(1),
      width: "90%",
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }),
);

interface Form {
  userId: string,
  keiyakuClsCd: string,
  salesPersonCd: string,
  renewalMonth: number[],
  demandMonth: number[],
}


interface Prop {
  contractList: typeContractList[] | undefined,
  form: Form,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  monthList: number[],
  chipDelete: (i: number, name: string) => void,
  onSubmit: () => void,
  customerList: typeCustomerList[] | undefined,
  handleChangeCompanyCd: (companyObj: typeCustomerList | null) => void,
  handleChangeKeiyakuCd: (keiyakuObj: typeContractList | null) => void,
  cisUserList: typeCisUserList[] | undefined,
  handleChangeSalesCd: (seObj: typeCisUserList | null) => void,
  loginUser: boolean,
  handleSetLoginUserCd: (event: React.ChangeEvent<HTMLInputElement>) => void,
  loading: boolean,
}

const ITEM_HEIGHT = 90;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      minWidth: 200,
      maxWidth: 200
    }
  }
};
const ContractListForm: React.FC<Prop> = (props) => {
  const classes = useStyles();
  const { contractList, form, handleChangeForm, monthList, chipDelete, onSubmit, customerList, handleChangeCompanyCd, handleChangeKeiyakuCd, cisUserList, handleChangeSalesCd, loginUser, handleSetLoginUserCd, loading, } = props

  const [expanded, setExpanded] = React.useState<string | false>('panel');

  const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <React.Fragment>
      <Accordion expanded={expanded === 'panel'} onChange={handleChange('panel')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="filtering"
          id="filtering-header"
        >
          <Typography className={classes.heading}>契約 検索条件</Typography>
        </AccordionSummary>
        <AccordionDetails style={{ padding: '0' }}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Paper elevation={0} className={classes.paper}>
              <Grid item xs={12} sm={8}>
                {customerList && customerList[0] && (
                  <FormControl className={classes.departmentWidth} variant="outlined" margin="dense" >
                    <Autocomplete
                      id="custmNo"
                      options={customerList!}
                      getOptionLabel={(option) => option.customerName}
                      onChange={(event, value, reason) => handleChangeCompanyCd(value)}
                      defaultValue={customerList!.filter(value => value.departmentCd === form.userId)[0]}
                      renderInput={(params) => (
                        <TextField {...params} label="顧客名 / 組織名" variant="outlined" size="small" />
                      )}
                      renderOption={(option, { inputValue }) => {
                        const matches = match((option.customerName), inputValue);
                        const parts = parse((option.customerName), matches);
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={8}>
                {contractList && contractList[0] && (
                  <FormControl className={classes.departmentWidth} variant="outlined" margin="dense" >
                    <Autocomplete
                      id="keiyakuClsCd"
                      options={contractList!}
                      getOptionLabel={(option) => option.keiyakuClsName}
                      defaultValue={contractList!.filter(value => value.keiyakuClsCd === form.keiyakuClsCd)[0]}
                      onChange={(event, value, reason) => handleChangeKeiyakuCd(value)}
                      renderInput={(params) => (
                        <TextField {...params} label="契約項目" variant="outlined" size="small" />
                      )}
                      renderOption={(option, { inputValue }) => {
                        const matches = match((option.keiyakuClsName), inputValue);
                        const parts = parse((option.keiyakuClsName), matches);
                        return (
                          <div>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}
                          </div>
                        );
                      }}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1} direction="row" justify="flex-start" alignItems="center">
                  <Grid item xs={5}>
                    {cisUserList && cisUserList[0] &&
                      <FormControl className={classes.departmentWidth} variant="outlined" margin="dense">
                        <Autocomplete
                          id="salesPersonCd"
                          disabled={loginUser}
                          options={cisUserList}
                          defaultValue={cisUserList!.filter(value => value.userCd === form.salesPersonCd)[0]}
                          getOptionLabel={(option) => `${option.userCd} ${option.userName}`}
                          onChange={(event, value, reason) => handleChangeSalesCd(value)}
                          renderInput={(params) => (
                            <TextField {...params} label="担当営業者" variant="outlined" size="small" />
                          )}
                          renderOption={(option, { inputValue }) => {
                            const matches = match(`${option.userCd} ${option.userName}`, inputValue);
                            const parts = parse(`${option.userCd} ${option.userName}`, matches);
                            return (
                              <div>
                                {parts.map((part, index) => (
                                  <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                    {part.text}
                                  </span>
                                ))}
                              </div>
                            );
                          }}
                        />
                      </FormControl>
                    }
                  </Grid>
                  <Grid item>
                    <FormControlLabel control={<Checkbox checked={loginUser} color="primary" onChange={handleSetLoginUserCd} name="loginUser" size="small" />} label="ログインユーザー" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.lWidth} margin="dense">
                  <InputLabel id="renewalMonth" variant="outlined">契約更新月</InputLabel>
                  <Select labelId="renewalMonth" id="renewalMonth" label="契約更新月" name="renewalMonth" multiple
                    value={form.renewalMonth} onChange={handleChangeForm} MenuProps={MenuProps}
                    renderValue={(selected) => (
                      <div className={classes.chips}>
                        {(selected as number[]).map((value) => (
                          <Chip
                            className={classes.chip}
                            color="primary"
                            variant="outlined"
                            size="small"
                            key={value}
                            label={value === 13 ? '解約' : `${value}月`}
                            onMouseDown={(event) => {
                              event.stopPropagation();
                            }}
                            onDelete={(event) => chipDelete(value, 'renewalMonth')} />
                        ))}
                      </div>
                    )}
                  >
                    {monthList.map((value) => (
                      <MenuItem key={value} value={value}>
                        <Checkbox color="primary" checked={form.renewalMonth.indexOf(value) > -1} />
                        <ListItemText primary={value === 13 ? '解約' : `${value}月`} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl variant="outlined" className={classes.lWidth} margin="dense">
                  <InputLabel id="demandMonth" variant="outlined">請求月</InputLabel>
                  <Select labelId="demandMonth" id="demandMonth" label="請求月"
                    name="demandMonth" multiple value={form.demandMonth} onChange={handleChangeForm} MenuProps={MenuProps}
                    renderValue={(selected) => (
                      <div className={classes.chips}>
                        {(selected as number[]).map((value) => (
                          <Chip
                            className={classes.chip}
                            color="primary"
                            variant="outlined"
                            size="small"
                            key={value}
                            label={`${value}月`}
                            onMouseDown={(event) => {
                              event.stopPropagation();
                            }}
                            onDelete={(event) => chipDelete(value, 'demandMonth')} />
                        ))}
                      </div>
                    )}
                  >
                    {monthList.filter(value => value !== 13).map((value) => (
                      <MenuItem key={value} value={value}>
                        <Checkbox color="primary" checked={form.demandMonth.indexOf(value) > -1} />
                        <ListItemText primary={`${value}月`} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} >
                <Grid container justify="center">
                  <div className={classes.wrapper}>
                    <Button variant="contained" color="primary" className={classes.button} disabled={loading} onClick={onSubmit} >
                      検索</Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </div>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </React.Fragment >
  )
}

export default ContractListForm